import { SituacaoFatura } from '../../../../../../_metronic/helpers'
import { createListFilters, IOption } from '../../../../../components'

export type FaturasFilters = {
  empresa?: IOption<number>
  mes?: IOption<string>
  ano?: IOption<number>
  situacao?: IOption<SituacaoFatura>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<FaturasFilters>({
  empresa: undefined,
  mes: undefined,
  ano: undefined,
  situacao: undefined,
})
